import { MODEL_IMAGES } from "./types"
import { cn } from "@/lib/utils"

interface PreviewOverlayImageSelectorProps {
  image: string
  onChange: (url: string) => void
}

export const PreviewOverlayImageSelector = ({
  image,
  onChange,
}: PreviewOverlayImageSelectorProps) => {
  return (
    <div className="flex items-center gap-1.5">
      {MODEL_IMAGES.map((url) => (
        <button
          key={url}
          type="button"
          onClick={() => onChange(url)}
          className={cn(
            "h-10 w-10 shrink-0 cursor-pointer overflow-hidden rounded-full border-2 transition-all",
            url === image
              ? "border-white shadow-lg shadow-white/20 scale-110"
              : "border-white/20 opacity-70 hover:opacity-100 hover:border-white/50"
          )}
        >
          <img src={url} alt="Model" className="h-full w-full object-cover" />
        </button>
      ))}
    </div>
  )
}
